/* eslint-disable no-param-reassign */
import produce from "immer";

import {
  LOAD_TRIP_REQUEST,
  RESET_TRIP_REQUEST,
} from "../actions/tripActions";

const initialState = {
  trips: {},
};

const tripReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_TRIP_REQUEST:
    case RESET_TRIP_REQUEST: {
      const { trips } = action.payload;
      return produce(state, (draft) => {
        draft.trips = trips;
      });
    }

    default: {
      return state;
    }
  }
};

export default tripReducer;
